import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Loader, Modal, ShareModalProps } from "ui";

import { useGetMerchantPrice, useUpdateMerchantPrice } from "../../../apis";
import { MerchantPriceForm } from "../../forms";

import styles from "./MerchantPriceModal.module.scss";

const MERCHANT_PRICE_FORM_ID = "MERCHANT_PRICE_FORM_ID";

const MerchantPriceModal = ({ isOpen, onClose }: ShareModalProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { merchantPrice, isMerchantPriceLoading } = useGetMerchantPrice();

  const updateMerchantPrice = useUpdateMerchantPrice({
    onSuccess: (response) => {
      onClose();
      queryClient.setQueryData(["flex-data", "merchant-price"], response);
      toast.success(t("Merchant price updated successfully"));
    }
  });

  return (
    <Modal
      type="primary"
      isOpen={isOpen}
      title={t("Merchant Price")}
      className={styles.modal}
      okText="Save"
      isLoading={isMerchantPriceLoading || updateMerchantPrice.isLoading}
      onClose={onClose}
      formId={MERCHANT_PRICE_FORM_ID}
    >
      {isMerchantPriceLoading && <Loader />}

      {merchantPrice !== undefined && (
        <MerchantPriceForm
          formId={MERCHANT_PRICE_FORM_ID}
          defaultMerchantPrice={merchantPrice}
          onSubmit={(data) => updateMerchantPrice.mutate(data)}
        />
      )}
    </Modal>
  );
};

export default MerchantPriceModal;
